module.exports = __webpack_public_path__ + "img/icon-quest.493c0f8d.svg";